<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-chart-multiple"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Analíticos de CA
        </div>
      </template>

      <v-btn
        id="btn-novo-calculo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float:left"
        relative
        text
        medium
        @click="$router.push(`/saneamento-voc/analiticos-ca/add/${$route.params.id}`);"
      >
        <v-icon left size="30px">
          mdi-plus-circle
        </v-icon>
        NOVO ANALÍTICO DE CA
      </v-btn>

      <v-text-field
        id="analitico-ca-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-4 break-search bs-analitico-ca"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <general-progress-bars
        class="mt-11"
        :items="downloadProgressData"
        prefixText="Baixando Analítico de CA"
      />

      <v-divider class="mt-10" />

      <v-data-table
        class="analitico-ca-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :loading="loadingItems"
        no-data-text="Nenhum Analítico de CA disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :headerProps="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.id`]="{ item }">{{ item.id }}</template>
        <template v-slot:[`item.numFiltros`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div 
                class="text-truncate-column clickable-item" 
                @click="openDialogDetalhes(item)"
                v-bind="attrs" v-on="on"
              >
                {{ item.numFiltros }}
              </div>
            </template>
            <span> Visualizar Filtros </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">{{ item.usuario }}</template>
        <template v-slot:[`item.executed`]="{ item }">{{ item.executed }}</template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-analitico-ca"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="downloadItem(item, item.usuario)"
            :loading="(downloadProgressData[item.id] !== undefined) ? true : false"
          >
            <v-icon small>
              mdi-download
            </v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-analitico-ca"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs" v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="canRunItem(item)"
                @click="executarItem(item.id)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-play</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="canDeleteItem(item)"
                @click="openDialogDelete(item.id, item.nome)"
              >
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  Deletar
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
          
      </v-data-table>
    </base-material-card>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Filtros"
      :showDialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button" width="210px">{{row.item.parametro}}</td>
              <td 
                class="button" 
                v-if="row.item.parametro.indexOf('OBRAS') == -1 && row.item.parametro.indexOf('TIPOLOGIAS') == -1"
              >
                {{row.item.valor}}
              </td>
              <td class="button" v-else style="padding-left:0px !important;">
                <v-textarea
                  rows="5"
                  no-resize
                  readonly
                  class="ml-4 mt-0 pt-0"
                  :value="row.item.valor"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>

    <dialog-delete 
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Analítico de CA #{{dialogDeleteData.id}}</template>
      <template slot="body">Tem certeza que deseja deletar esse Analítico de CA?</template>
    </dialog-delete>
  </v-container>
</template>

<script>

import AnaliticoCaService from '@/services/AnaliticoCaService.js';
import powerupsActionsMixis from '@/mixins/powerupsActionsMixins.js';

export default {
  name: 'AnaliticosCaDataTable',

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import("@/components/general/GeneralProgressBars.vue"),
    GeneralStatus: () => import("@/components/general/GeneralStatus.vue"),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loadingItems: {
      type: Boolean,
      default: false,
    }
  },

  mixins: [powerupsActionsMixis],

  data: () => ({
    powerupService: AnaliticoCaService,
    powerupEntityName: "Analítico de CA",
    search: "",
    headers: [
      {
        text: "#",
        value: "id"
      },
      {
        text: "Filtros",
        value: "numFiltros"
      },
      {
        text: "Usuário",
        value: "usuario"
      },
      {
        text: "Executado",
        value: "executed"
      },
      {
        text: "Status",
        value: "status"
      },
      {
        sortable: false,
        text: "Ações",
        value: "actions",
        class: "pl-4"
      }
    ],
    dialogDetalhesHeader: [
      { text: 'Campo', value: 'parametro', sortable: false },
      { text: 'Valor', value: 'valor', sortable: false }
    ],
  }),

  methods: {
    openDialogDetalhes(item) {   
      this.dialogDetalhesData = [
        {
          parametro: 'OBRAS:',
          valor: item.filtros.obras,
        },
        {
          parametro: 'TIPOLOGIAS:',
          valor: item.filtros.tipologias,
        },
        {
          parametro: 'DATA DE IMOBILIZAÇÃO DE:',
          valor: item.filtros.dataImobilizacaoInicial ? item.filtros.dataImobilizacaoInicial : "-",
        },
        {
          parametro: 'DATA DE IMOBILIZAÇÃO ATÉ:',
          valor: item.filtros.dataImobilizacaoFinal ? item.filtros.dataImobilizacaoFinal : "-",
        },
        {
          parametro: 'FLAG 1: OBRA COM UAR <= 10%:',
          valor: this.getFiltroFlagText(item.filtros.flags.FLG_ODI_UAR_ZERO),
        },
        {
          parametro: 'FLAG 2: FLAG 90:',
          valor: this.getFiltroFlagText(item.filtros.flags.FLG_ERR_DT_LMTO),
        },
      ];
        
      this.dialogDetalhes = true;
    },
    getFiltroFlagText(flag) {
      return flag == '' ? "Todas as linhas" : flag == '1' ? "Somente linhas aprovadas" : "Somente linhas que falharam"
    },
  }
}
</script>

<style>
  @media screen and (min-width: 800px) {
    .analitico-ca-table table tr td:nth-child(5),
    .analitico-ca-table table tr td:nth-child(6) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-analitico-ca {
      width: 209.91px !important;
    }
  }
</style>